import { Injectable } from '@angular/core';
// import { ToastController, LoadingController } from '@ionic/angular';
import { Constants } from 'src/app/constants/constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnvService } from '../service/env.service';
import countries from '../../assets/jsondata/countries.json';

@Injectable({
	providedIn: 'root'
})
export class UtilService {

	loading = null;
	selectedRentalFleetAccount = null;
	selectedAccountUser = null;
	isHideLocation = true;
	selectedTrip = null;
	isOpenFromSearch = false;
	isSearchFromUserList = false;

	SERVICE_ICON_MAPPING = [
		{ "command": Constants.REMOTE_DOOR_LOCK, "icon": "/assets/svg/door-open.svg" },
		{ "command": Constants.REMOTE_DOOR_UNLOCK, "icon": "/assets/svg/door-close.svg" },
		{ "command": Constants.REMOTE_ENGINE_START, "icon": "/assets/svg/engine-start.svg" },
		{ "command": Constants.REMOTE_ENGINE_STOP, "icon": "/assets/svg/engine-stop.svg" },
		{ "command": Constants.REMOTE_HORN, "icon": "/assets/svg/horn.svg" },
		{ "command": Constants.REMOTE_HORN_LIGHT, "icon": "/assets/svg/light-off.svg" },
		{ "command": Constants.REMOTE_LIGHT, "icon": "/assets/svg/light-on.svg" },
		{ "command": Constants.REMOTE_LOCATION, "icon": "/assets/svg/location.svg" }
	];

	// Europe
	// countryData = {
	// 	"country": "Spain",
	// 	"region": "Europe",
	// 	"currency": "EUR",
	// 	"currencySign": "€",
	// 	"dateFormat": "dd/MM/yyyy",
	// 	"timeFormat": "hh:mm:ss a",
	//	"timeFormatHHMM": "hh:mm a",
	// 	"timezone": null
	// };

	//US
	countryData = {
		"country": "US",
		"region": "North America",
		"currency": "USD",
		"currencySign": "$",
		"dateFormat": "MM/dd/yyyy",
		"timeFormat": "hh:mm:ss a",
		"timeFormatHHMM": "hh:mm a",
		"timezone": "UTC"
	};

	// constructor(private toastCtrl: ToastController, private loadingCtrl: LoadingController) { }
	constructor(public spinner: NgxSpinnerService, private env: EnvService) {
	}

	// Not getting used
	setCurrency(country) {
		this.countryData.currency = "EUR"; //"€";
		this.countryData.currencySign = "€";
	}

	// Not getting used
	setCountryDateFormat(country) {
		this.countryData.dateFormat = "dd/MM/yyyy";
		this.countryData.timeFormat = "hh:mm:ss a";
		this.countryData.timezone = null;
	}

	showSpinner() {
		this.spinner.show();
	}

	hideSpinner() {
		this.spinner.hide();
	}

	toTitleCase(str) {
		return str.replace(
			/\w\S*/g,
			function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			}
		);
	}

	convertMonthsToYearsAndMonths(months): string {
		months = Number(months);
		if (months < 12) return months + " Months";

		var years = Math.floor(months / 12);
		var term = years + "";

		term = (years > 1) ? term + " Years" : term + " Year";
		var month = (months % 12);
		if (month == 0) return term;
		term = term + ", " + month;
		term = (month > 1) ? term + " Months" : term + " Month";
		return term;
	}

	// makeReservationReqModel: MakeReservationRequestModel = new MakeReservationRequestModel();

	// async showToast(message: string, duration: number) {
	// 	const toast = await this.toastCtrl.create({
	// 		message: message,
	// 		position: 'middle',
	// 		duration: duration
	// 	});
	// 	toast.present();
	// }

	// async showSpinner() {
	// 	this.loading = await this.loadingCtrl.create({
	// 		message: 'Please wait...',
	// 		translucent: true,
	// 		cssClass: 'custom-class custom-loading'
	// 	});
	// 	return await this.loading.present();
	// }

	// dismissSpinner() {
	// 	if (this.loading)
	// 		this.loading.dismiss();
	// }

	// getUTCConvertedDateString(dateString: string) {
	// 	var date: Date = new Date(dateString);
	// 	return new Date(date.getTime() + date.getTimezoneOffset() * 60000).toISOString();
	// }

	// getIcon(command: string) {
	// 	var icon = "";
	// 	for (var i = 0; i < this.SERVICE_ICON_MAPPING.length; i++) {
	// 		if (this.SERVICE_ICON_MAPPING[i].command == command) {
	// 			icon = this.SERVICE_ICON_MAPPING[i].icon;
	// 			break;
	// 		}
	// 	}
	// 	return icon;
	// }

	ERROR_MAP = new Map<string, string>([
		["Invalid Api Key and App Type", "Unauthorized Access"]
	]);

	getErrorMessage(error: string) {
		if (this.ERROR_MAP.has(error)) return this.ERROR_MAP.get(error);
		return error;
	}

	// Account Type Name mapping
	accountTypeNameMap: Map<string, string> = new Map<string, string>([
		['RENTAL_COMMERCIAL_FLEET', 'Rental / Commercial Fleets'],
		['VEHICLE_SERVICE_PROVIDER', 'Service Providers / Consumers'],
		['INTERNAL_AFFILIATES', 'Internal / Affiliates']
	]);

	getAccountTypeName(value) {
		if (this.accountTypeNameMap.has(value)) {
			return this.accountTypeNameMap.get(value);
		}
		return value
	}

	splitIsdAndPhone(phoneNumber) {
		/* TRYOUT CODE FOR FUTURE REFERENCE:
		let searchIn = '+1987+16543+1210';
		let searchThis = "[+]1";
		let replaceWith = "";
		console.log(searchIn.replace(new RegExp(searchThis, "g"), replaceWith)); // Output: 9876543210
		*/

		//TODO : Handle logic to split isd from phone.
		var obj = {
			isd: Constants.LOCALE_ISD_MAP.get(this.env.LOCALE),
			phone: phoneNumber.replace(/\+1/g, "")
		}
		return obj;
	}

	getDateDifference(epochMillis): number {
		if (epochMillis == null || epochMillis == undefined) return 0;
		return Math.floor((new Date().getTime() - new Date(epochMillis).getTime()) / (1000 * 3600 * 24));;
	}

	/**
	 * CONVERTERs
	 */
	kmToMile(value: number) {
		return value * Constants.KM_TO_MILE;
	}

	literToGallon(value: number) {
		return value * Constants.LITER_TO_GALLON;
	}

	mmCubeToGallon(value: number) {
		return this.literToGallon(value * Constants.MMCUBE_TO_LITER);
	}

	kmphToMph(value: number) {
		return value * Constants.KMPH_TO_MPH;
	}

	barToPsi(value: number) {
		return value * Constants.BAR_TO_PSI;
	}

	mBarToPsi(value: number) {
		return this.barToPsi(value / 1000);
	}

	kmplToMpg(value: number) {
		return value * Constants.KMPL_TO_MPG;
	}

	replaceTextInStatement(statement: string, oldText: string, newText: string): string {
		const regex = new RegExp(oldText, "g");
		const replacedStatement = statement.replace(regex, newText);
		return replacedStatement;
	}

	doesAccountSupportsDongle(category: any) {
		return false;
		if (['DEALER', 'CORPORATE'].includes(category))
			return true;
		return false;
	}

	getCountryList(region?: string): any[] {
		if (!region)
			return countries;

		let filteredCountries = countries.filter(country => country.continent == region);
		return filteredCountries;
	}

	getDefaultCountry(): any {
		return 'United States';
	}

	getYYYYMMDD(date) {
		var mm = date.getMonth() + 1;
		var dd = date.getDate();

		return [date.getFullYear(),
		(mm > 9 ? '' : '0') + mm,
		(dd > 9 ? '' : '0') + dd
		].join('');
	}

	getYYYYMMDDhhmm(date: Date) {
		var mm = date.getMonth() + 1;
		var dd = date.getDate();
		var hh = date.getHours();
		var min = date.getMinutes();

		return [date.getFullYear(),
		(mm > 9 ? '' : '0') + mm,
		(dd > 9 ? '' : '0') + dd,
		(hh > 9 ? '' : '0') + hh,
		(min > 9 ? '' : '0') + min
		].join('');
	}

	isEnrolledForData(vehicle, accountId) {
		if (vehicle.enrolledForData == true && this.isNmacAccount(accountId))
			return true;
		return false;
	}

	isNmacAccount(accountId) {
		if (accountId == Constants.NMAC_ACCOUNT_ID)
			return true;
		return false;
	}	

	stringFormat(format: any, ...args: any) {
		if (format) {
			return format.replace(/%s/g, () => {
				return args.length > 0 ? args.shift() : "%s";
			});
		}
		return format;
	}

	checkPhoneWithIsd(phone: string) {
		if (phone != null && phone.length > 10 && phone.startsWith("+1")) {
			phone = phone.substring(2, phone.length);
		}
		return phone;
	}

	getVehicleEnrollmentStatus(vehicle: any): string {
		const status = vehicle.enrollmentStatus;
		const enrolledForData = vehicle.enrolledForData;

		const enrollmentInProgressStatuses = [
			Constants.ENROLLMENT_IN_PROGRESS, Constants.ENROLLMENT_INITIATED, Constants.ENROLLMENT_RETRY
		];

		const unenrollmentInProgressStatuses = [
			Constants.UNENROLLMENT_IN_PROGRESS, Constants.UNENROLLMENT_RETRY, Constants.UNENROLLMENT_INITIATED
		];

		if (enrollmentInProgressStatuses.includes(status)) {
			return enrolledForData
				? 'Data Enrolled | API Enrollment In Progress'
				: 'API Enrollment In Progress';
		}

		if (unenrollmentInProgressStatuses.includes(status)) {
			return enrolledForData
				? 'Data Enrolled | API Unenrollment In Progress'
				: 'API Unenrollment In Progress';
		}

		if (status === Constants.ENROLLMENT_FAILED && enrolledForData) {
			return 'Data Enrolled | API Enrollment Failed';
		}

		if (status === Constants.UNENROLLMENT_FAILED && enrolledForData) {
			return 'Data Enrolled | API Unenrollment Failed';
		}

		if (status === Constants.ENROLLED) {
			return 'Enrolled';
		}

		if (enrolledForData) {
			return 'Data Enrolled';
		}

		return status;
	}
}

export enum PagePointer {
	PREVIOUS = "prev",
	NEXT = "next"
}